import { render, staticRenderFns } from "./TermosConfiguracao.vue?vue&type=template&id=8d45ba4a"
import script from "./TermosConfiguracao.vue?vue&type=script&lang=js"
export * from "./TermosConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports